import { render, staticRenderFns } from "./ConsultaSaldo.vue?vue&type=template&id=38a1ddf8&scoped=true"
import script from "./ConsultaSaldo.vue?vue&type=script&lang=js"
export * from "./ConsultaSaldo.vue?vue&type=script&lang=js"
import style0 from "./ConsultaSaldo.vue?vue&type=style&index=0&id=38a1ddf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1ddf8",
  null
  
)

export default component.exports